// Sidebar entries owned by the VCard module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { vCardPaths } from './paths'

export const vCardNav = {
    list: {
        title: 'vcard-list',
        path: vCardPaths.vcardList,
    },
} satisfies Record<string, SidebarType>
